import React from 'react';

import CustomDatePicker from 'components/SharedFormComponents/CustomDatePicker';

import { PickerProps } from '../types';

export const DatePicker: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <CustomDatePicker
    description=""
    {...props}
    onChange={(newValue) => {
      if (newValue && !Number.isNaN(newValue)) {
        applyValue({ ...item, value: newValue });
      }
    }}
    value={item?.value as string}
  />
);
